/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Geliver_NedirInputs */

const tr_faq_a_geliver_nedir = /** @type {(inputs: Faq_A_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliver, kargo anlaşması olan bir gönderim aracısıdır. Shopify mağazandan veya bağımsız satışlarından aldığın siparişleri Geliver üzerinden kolayca gönderebilirsin. Trendyol, Hepsiburada ve n11 siparişleri kendi kargo sistemlerini kullanır; bu pazaryerleri için Geliver devreye girmez.`)
};

const en_faq_a_geliver_nedir = /** @type {(inputs: Faq_A_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliver is a shipping aggregator, not a sales platform. Use it to send orders from your Shopify store or standalone sales. Trendyol, Hepsiburada and n11 each have their own integrated carrier system.`)
};

const de_faq_a_geliver_nedir = /** @type {(inputs: Faq_A_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliver ist ein Versanddienstleister, kein Verkaufskanal. Du kannst ihn für Shopify-Bestellungen oder eigenständige Verkäufe nutzen. Trendyol, Hepsiburada und n11 haben jeweils ihr eigenes integriertes Versandsystem.`)
};

const ru_faq_a_geliver_nedir = /** @type {(inputs: Faq_A_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliver - это агрегатор доставки, а не площадка для продаж. Используйте его для отправки заказов из Shopify или отдельных продаж. Trendyol, Hepsiburada и n11 имеют собственные системы доставки.`)
};

/**
* | output |
* | --- |
* | "Geliver is a shipping aggregator, not a sales platform. Use it to send orders from your Shopify store or standalone sales. Trendyol, Hepsiburada and n11 each..." |
*
* @param {Faq_A_Geliver_NedirInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_geliver_nedir = /** @type {((inputs?: Faq_A_Geliver_NedirInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Geliver_NedirInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_geliver_nedir(inputs)
	if (locale === "de") return de_faq_a_geliver_nedir(inputs)
	if (locale === "ru") return ru_faq_a_geliver_nedir(inputs)
	return tr_faq_a_geliver_nedir(inputs)
});